import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { DealCycleApiService } from '../services/deal-cycle-api.service';
import { DealCycleResponse } from '../models/deal-cycle.model';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-deal-cycle-list',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, PageBreadcrumbComponent, HasPermissionDirective],
  templateUrl: './deal-cycle-list.component.html',
})
export class DealCycleListComponent implements OnInit {
  items: DealCycleResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private api: DealCycleApiService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.error = '';

    this.api.getAll().subscribe({
      next: (data) => {
        this.items = data;
        this.loading = false;
      },
      error: (err) => {
        this.error =
          err.error?.message || 'Error al cargar las etapas del pipeline';
        this.loading = false;
        console.error('Error:', err);
      },
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-deals/ciclos/crear']);
  }

  editar(item: DealCycleResponse): void {
    this.router.navigate(['/config-deals/ciclos/editar', item.id]);
  }

  async eliminar(item: DealCycleResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar etapa',
      message: `¿Está seguro de eliminar la etapa "${item.name}"?`,
    });
    if (!ok) return;
    this.api.delete(item.id).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Etapa del pipeline', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.confirmDialog.alert({
          title: 'Error',
          message: err.error?.message || 'Error al eliminar la etapa',
          variant: 'danger',
        });
        this.toast.error({
          title: 'Erorr',
          message: err.error?.message || 'Error al eliminar la etapa',
        });
      },
    });
  }
}
